<template>
  <div class="notifyPage modelPage">
    <van-nav-bar
      left-arrow
      left-text="メッセージ一覧"
      @click-left="onClickLeft"
    >
      <template #right v-if="data && data.length > 0">
        <div
          class="operateText"
          @click="
            result = [];
            checked = false;
            isEdit = !isEdit;
          "
        >
          {{ isEdit ? "キャンセル" : "編集" }}
        </div>
      </template>
    </van-nav-bar>
    <div class="notifyConent">
      <van-tabs v-model="activeName" @click="onClick">
        <van-tab
          v-for="(item, index) in type"
          :key="index"
          :title="item.title"
          :name="index"
        >
          <template #title>
            <b v-if="item.unRead" class="redNotice"></b> {{ item.title }}
          </template></van-tab
        >
      </van-tabs>
      <van-checkbox-group v-model="result" ref="checkboxGroup">
        <div class="items" v-for="(item, index) in data" :key="index">
          <div style="display: flex;" v-if="item.messageBody">
            <div class="top">
              <span class="title">{{ item.messageBody.title }} </span>
              <div class="radius" v-if="item.readFlag == 0"></div>
            </div>
            <!-- readFlag  boolean 0未读，1已读 -->
            <van-checkbox
              v-if="isEdit"
              :name="item.id"
              shape="square"
            ></van-checkbox>
          </div>
          <div class="time" v-if="item.messageBody">
            {{ item.messageBody.createTime }}
          </div>
          <div
            class="desc"
            v-if="item.messageBody"
            v-html="item.messageBody.content"
            @click="
              $router.push({ path: `/notifyDetail`, query: { id: item.id } })
            "
          ></div>
        </div>
      </van-checkbox-group>
      <div v-if="noData" class="noData mtop16">該当する結果が見つかりませんでした~</div>
    </div>
    <div class="operate" v-if="isEdit">
      <van-checkbox v-model="checked" shape="square" @change="isCheckAll"
        >すべてを選択</van-checkbox
      >
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="yiduBtn btn"
        :loading="loading"
        @click="yidu()"
        >既読にする</van-button
      >
      <!-- <div class="yiduBtn btn" @click="yidu()">既読にする</div> -->
      <div class="delBtn btn" @click="delBtn()">削除</div>
    </div>

    <van-popup v-model="goDelPopup" closeable>
      <div class="content">
        <div>メッセージを削除しますか？</div>
      </div>
      <div class="buttonItem">
        <div class="button cancel" @click="goDelPopup = false">
          キャンセル
        </div>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="button del"
          :loading="loadingDel"
          @click="saveDelNoity()"
          >削除</van-button
        >
        <!-- <div class="button del" @click="saveDelNoity()">削除</div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
import { Checkbox, CheckboxGroup } from "vant";

import { Toast } from "vant";

Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tab);
Vue.use(Tabs);
import {
  messageType,
  messageMember,
  updateMessageStatus,
  deleteMessage
} from "@/http/user";
export default {
  data() {
    return {
      isEdit: false,
      activeName: "0",
      type: [],
      data: [],
      result: [],
      checked: false,
      goDelPopup: false,
      noData: false,
      loading: false,
      loadingDel: false
    };
  },
  mounted() {
    this.getMessageType();
  },
  methods: {
    getMessageType() {
      messageType().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          if (data && data.length > 0) {
            this.type = data;
            if (data.findIndex(target => target.unRead == true) == -1) {
              //没有未读
              this.activeName = 0;
              this.getData(data[0].id);
              return;
            }
            for (let i in data) {
              if (data[i].unRead) {
                this.activeName = Number(i);
                this.getData(data[i].id);
                break;
              }
            }
          } else {
            this.noData = true;
          }
        }
      });
    },
    getData(id) {
      let query = {
        messageType: id,
        pageNo: 1,
        pageSize: 100
      };
      messageMember(query).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          if (data && data.list.length > 0) {
            this.data = data.list;
            this.noData = false;
          } else {
            this.noData = true;
          }
        }
      });
    },
    onClick() {
      let i = this.activeName;
      let id = this.type[i].id;
      this.data = [];
      this.getData(id);
    },
    isCheckAll() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
    },
    onClickLeft() {
      this.$router.back(1);
    },
    yidu() {
      if (this.result.length < 1) {
        Toast({
          type: "fail",
          icon: "cross",
          message: "マークアップするメッセージを選択してください"
        });
        return;
      }
      let id = this.result;
      this.loading = true;
      updateMessageStatus({ ids: id }).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            message: "既読にしました"
          });
          this.onClick();
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
        }
        this.isEdit = false;
        this.loading = false;
        this.goDelPopup = false;
      });
    },
    delBtn() {
      if (this.result.length < 1) {
        Toast({
          type: "fail",
          icon: "cross",
          message: "削除するメッセージを選択してください"
        });
        return;
      }
      this.goDelPopup = true;
    },
    saveDelNoity() {
      let id = this.result;
      this.loadingDel = true;
      deleteMessage(id).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            message: "削除しました"
          });
          this.onClick();
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
        }
        this.isEdit = false;
        this.loadingDel = false;
        this.goDelPopup = false;
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style>
.notifyPage.modelPage {
  /* height: calc(100% - 60px); */
  /* height: 100%; */
}
.notifyPage .operateText {
  font-family: MediumFont;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
}
.notifyPage .notifyConent {
  width: calc(100% - 30px);
  height: calc(100% - 70px);
  margin: 0 auto;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 12px;
}
.notifyPage .van-tabs__nav {
  border-radius: 80px;
}
.notifyPage .van-tab {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
}
.notifyPage .van-tabs__nav--line {
  padding: 0;
}
.notifyPage .van-tab.van-tab--active {
  background: #2b99ff;
  border-radius: 80px;
  color: #ffffff;
}
.notifyPage .van-tabs__line {
  display: none;
}
.notifyPage .items {
  border-radius: 8px;
  padding: 16px;
  max-height: 124px;
  margin-top: 16px;
  font-size: 14px;
  line-height: 22px;
  width: 100%;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.9);
  box-sizing: border-box;
  /* 卡片投影 */
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
}
.notifyPage .items .top {
  display: flex;
  /* justify-content: space-between; */
  width: calc(100% - 20px);
}
.notifyPage .items .top .title {
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 22px;
  position: relative;
}
.notifyPage .redNotice {
  width: 6px;
  height: 6px;
  margin-bottom: 6px;
  margin-right: 2px;
  border-radius: 50%;
  opacity: 1;
  content: " ";
  color: red;
  display: inline-block;
  /* red */
  background: #ff2f6a;
}
.notifyPage .items .top .radius {
  width: 12px;
  position: relative;
}
.notifyPage .items .top .radius:after {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  opacity: 1;
  content: " ";
  color: red;
  display: inline-block;
  /* red */
  background: #ff2f6a;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 6;
  display: block;
}
.notifyPage .items .desc {
  width: 100%;
  max-height: 44px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.notifyPage .items .desc p {
  margin: 0;
  padding: 0;
}
.notifyPage .items .time {
  font-size: 12px;
  margin: 1px 0 3px 0;
  color: rgba(0, 0, 0, 0.5);
}
.notifyPage .van-checkbox__icon {
  font-size: 19px;
  line-height: 19px;
  border-radius: 2px;
}
.notifyPage .van-checkbox__icon .van-icon {
  width: 19px;
  height: 19px;
  font-size: 14px;
  line-height: 19px;
  border-radius: 2px;
}
.notifyPage .operate {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 32px);
  margin: 0 auto;
}
.notifyPage .operate .btn {
  width: 96.5px;
  height: 44px;
  line-height: 44px;
  border-radius: 60px;
  font-size: 16px;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
}
.notifyPage .operate .btn.yiduBtn {
  color: rgba(0, 0, 0, 0.9);
  border: 1.5px solid #2b99ff;
  background: transparent;
  padding: 0;
}
.aiCenter .notifyPage .van-popup .button.del {
  border: none !important;
}
.notifyPage .operate .btn.delBtn {
  color: rgba(255, 255, 255, 0.9);
  border: none;
  background: #ff2f6a;
}
.notifyPage .noData {
  font-size: 14px;
  margin-top: 16px;
  text-align: center;
}

@media screen and (min-width: 1439px) {
  .notifyPage .van-tabs--line .van-tabs__wrap {
    height: 44px; /* no*/
  }
  .notifyPage .operateText {
    font-size: 16px; /* no*/
    line-height: 22px; /* no*/
  }
  .notifyPage .notifyConent {
    width: calc(100% - 32px); /* no*/
    height: calc(100% - 60px); /* no*/
    margin: 0 auto; /* no*/
  }
  .notifyPage .van-tabs__nav {
    border-radius: 80px; /* no*/
  }
  .notifyPage .van-tab {
    height: 44px; /* no*/
    line-height: 44px; /* no*/
    font-size: 14px; /* no*/
  }
  .notifyPage .van-tab.van-tab--active {
    border-radius: 80px; /* no*/
  }
  .notifyPage .items {
    border-radius: 8px; /* no*/
    padding: 16px; /* no*/
    max-height: 124px; /* no*/
    margin-top: 16px; /* no*/
    font-size: 14px; /* no*/
    line-height: 22px; /* no*/
    color: rgba(0, 0, 0, 0.9); /* no*/
    /* 卡片投影 */
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0); /* no*/
  }
  .notifyPage .items .top {
    width: calc(100% - 20px); /* no*/
  }
  .notifyPage .items .top .title {
    height: 22px; /* no*/
  }

  .notifyPage .items .top .radius {
    width: 12px; /* no*/
  }
  .notifyPage .items .top .radius:after {
    width: 6px; /* no*/
    height: 6px; /* no*/
  }
  .notifyPage .items .desc {
    max-height: 44px; /* no*/
  }
  .notifyPage .items .time {
    font-size: 12px; /* no*/
    margin: 1px 0 3px 0; /* no*/
  }
  .notifyPage .van-checkbox__icon {
    font-size: 19px; /* no*/
    line-height: 19px; /* no*/
    border-radius: 2px; /* no*/
  }
  .notifyPage .van-checkbox__icon .van-icon {
    width: 19px; /* no*/
    height: 19px; /* no*/
    font-size: 14px; /* no*/
    line-height: 19px; /* no*/
    border-radius: 2px; /* no*/
  }
  .notifyPage .operate {
    width: calc(100% - 32px); /* no*/
    font-size: 16px; /* no*/
  }
  .notifyPage .operate .btn {
    width: 96.5px; /* no*/
    height: 44px; /* no*/
    line-height: 44px; /* no*/
    border-radius: 60px; /* no*/
    font-size: 16px; /* no*/
  }
  .notifyPage .operate .btn.yiduBtn {
    border: 1.5px solid #2b99ff; /* no*/
  }
  .notifyPage .noData {
    font-size: 14px; /* no*/
    margin-top: 16px; /* no*/
  }
  .notifyPage .redNotice {
    width: 6px; /* no*/
    height: 6px; /* no*/
    margin-bottom: 6px; /* no*/
    margin-right: 2px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/notify.vue